module.exports = __webpack_public_path__ + "img/rocket.62373d4e.svg";